import { CellContext } from "@tanstack/react-table";
import { ClientDetailsRow } from "../clientViewConfig";

export const NameCell = (props: CellContext<ClientDetailsRow, string>) =>
    props.renderValue();
